export default "__VITE_ASSET__w_$WjFJo__"